'use client'

import { useEffect } from 'react'
import { useAttributionTracking } from '@/lib/attribution/useAttributionTracking'
import { attributionDebug } from '@/lib/attribution/logger'

export function AttributionTracking() {
  useAttributionTracking()

  useEffect(() => {
    attributionDebug('AttributionTracking component mounted')
  }, [])

  return null
}
